/* eslint-disable consistent-return */
import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ResultSection = styled.div(() =>
  mq({
    textAlign: 'left',
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    padding: defaultTheme.spacing.s,
    '& > p': {
      fontSize: defaultTheme.font.size.xs,
      fontWeight: 'bold',
      lineHeight: defaultTheme.font.height.base,
      marginBottom: defaultTheme.spacing.xs,
    },
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'left',
    padding: defaultTheme.spacing.s,
    paddingRight: '0px',
    '& > p': {
      color: defaultTheme.text.gray,
      fontSize: defaultTheme.font.size.xs,
      textAlign: 'center',
    },
  }),
);
